import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import {
  insAnketaChangeByKey,
  insAnketaInsurerChangeByKey,
  insAnketaInsurerSetError,
  insAnketaSetError,
} from 'store/insuranceAnketa';
import {
  selectError,
  selectErrors,
  selectField,
  selectInsuranceAnketa,
  selectKaskoInsurer,
  selectKaskoInsurerError,
  selectKaskoInsurerErrors,
  selectKaskoInsurerField,
} from 'store/insuranceAnketa/selectors';

export const useStoreHelper = ({ isOwnerForm }) => {
  const dispatch = useDispatch();

  const errorAction = isOwnerForm ? insAnketaSetError : insAnketaInsurerSetError;
  const errorSelector = isOwnerForm ? selectError : selectKaskoInsurerError;
  const errorsSelector = isOwnerForm ? selectErrors : selectKaskoInsurerErrors;

  const valueAction = isOwnerForm ? insAnketaChangeByKey : insAnketaInsurerChangeByKey;
  const valueSelector = isOwnerForm ? selectField : selectKaskoInsurerField;
  const valuesSelector = isOwnerForm ? selectInsuranceAnketa : selectKaskoInsurer;

  const onSetError = useCallback(
    ({ key, value }) => {
      dispatch(errorAction({ key, value }));
    },
    [errorAction]
  );
  const onChangeValue = useCallback(
    ({ key, value }) => {
      dispatch(valueAction({ key, value }));
      onSetError({ key, value: '' });
    },
    [valueAction, onSetError]
  );

  return {
    errorSelector,
    errorsSelector,
    onChangeValue,
    onSetError,
    valueSelector,
    valuesSelector,
  };
};
